/* eslint-disable import/no-extraneous-dependencies */
const litePlayerFnQueue = {};
let isLitePlayerReady = false;
export const excuteAfterLitePlayerReady = (id = 'minitv', fn) => {
  try {
    if (isLitePlayerReady) {
      fn();
    } else {
      litePlayerFnQueue[id] = litePlayerFnQueue[id] || [];
      litePlayerFnQueue[id].push(fn);
    }
  } catch (error) {
    fn();
  }
};

export const processLitePlayerFnQueue = (id = 'minitv') => {
  try {
    litePlayerFnQueue[id] = litePlayerFnQueue[id] || [];
    litePlayerFnQueue[id].forEach(fn => fn());
    isLitePlayerReady = true;
  } catch (error) {
    console.error('Error processing player queue:', error);
  }
};
